<template>
  <div>

    <AdvancedDynamicToggleCollapse
      :collapses="[{id:'Plan-filter', name:'Filter Plans', icon:'FilterIcon'}]">
      <b-collapse id="Plan-filter">
        <b-card>
          <b-row class="mt-2">
          <b-col sm="12" md="6">
            <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.owners"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...owners]" :reduce="d => d.id"
                v-on:input="reFilterPlans('owners', Object.assign(request)), refilterContractByOwner(request.owners)" />
              <small v-if="errors && ('owners' in errors)" class="text-danger">
                {{ $t(errors['owners'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group :label="$t('contracts')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.contracts"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...contracts]" :reduce="d => d.id" v-on:input="reFilterPlans('contracts', request)" />
              <small v-if="errors && ('contracts' in errors)" class="text-danger">
                {{ $t(errors['contracts'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
        </b-card>
      </b-collapse>

      <b-collapse id="Results-Aggregation">
        <b-card>
          <ResultsAggregationCard
            :groupByOptions="['owner', 'contract', 'device', 'plan']"
            :enabled.sync="request.aggregationEnabled"
            :period.sync=request.period
            :groupBy.sync=request.groupBy
            :errors=errors
            />
        </b-card>
      </b-collapse>
    </AdvancedDynamicToggleCollapse>

    <!-- form report -->
    <b-card style="position: relative" :title="$t('Select Plan & Time')">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <b-form @submit.prevent="getReport" class="">
        <b-row class="mt-2">
          <b-col :cols="report_type == 'report' ? 6 : 12">
            <b-form-group :label="$t('plans')" label-for="vi-plan-id">
              <v-select multiple :close-on-select="false" v-model="request.plans"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), id: 'all' }, ...plans]" :reduce="d => d.id" />
              <small v-if="errors && ('plans' in errors)" class="text-danger">
                {{ $t(errors['plans'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col v-if="report_type == 'report'" md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder=" new Date()" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{ ('from' in errors) ? errors['from'][0] : '' }}
                {{ ('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type == 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type == 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('garden')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <div v-if="reportData">
      <AdvancedDataTable :report_data="reportData" :report_fields="reportFields"
        :filter_included_fields="filterIncludedFields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData" />

    </div>



  </div>
</template>

<script>

import {
  BButton, 
  BTable, 
  BFormInvalidFeedback, 
  BCard, 
  BCollapse,
  BCol, 
  BFormCheckboxGroup,
  BForm, 
  BFormCheckbox, 
  BFormRadioGroup, 
  BFormGroup, 
  BFormInput, 
  BPagination,
  BInputGroup, 
  BInputGroupPrepend, 
  BRow, 
  BAlert, 
  BTabs, 
  BTab, 
  BCardText, 
  VBTooltip,
  BInputGroupAppend,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'
import reportLogic from '@/app/reports/containerWashPlan/logic'

import reportForm from '@/app/reports/containerWashPlan/reportForm'
import AdvancedDataTable from '@/views/reports/data-table/AdvancedDataTable.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'

import ReportOptions from '@/views/reports/components/options.js'

import AdvancedDynamicToggleCollapse from '@/views/ui/toggle-collapse/AdvancedDynamicToggleCollapse.vue'
import ResultsAggregationCard from '../ResultsAggregationCard.vue'

export default {
  name: 'ContainerWashPlan',
  components: {
    BRow,
    BCard,
    BCollapse,
    BFormCheckboxGroup, 
    BTable, 
    BPagination,
    BCol, 
    BFormRadioGroup, 
    BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, 
    flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner, 
    BInputGroupAppend,
    AdvancedDataTable,
    AdvancedDynamicToggleCollapse,
    ResultsAggregationCard
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },
  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },

  setup(props, { root }) {

    const tableRef = ref(null)
    const rangeDate = ref('')

    const { 
      owners,
      contracts,
      plans,
      reFilterPlans
    } = reportForm()
    
    const { 
      reportData,
      request,
      errors,
      loading,
      getReport,
      total,
      from,
      to,
      isSortDirDesc,
      sortBy,
      dataTableloading
    } = reportLogic()
    
    const sortData = (data)=>{
      sortBy.value = data.sortBy
      isSortDirDesc.value = data.isSortDirDesc
    }
    
    const filterIncludedFields = []
    
    const { pickerOptions } = ReportOptions(request.value)
    
    const reportFields = [
      {
        key: "date",
        label: "Date",
        sortable: true
      },
      {
        key: "day",
        label: "Day",
        sortable: true
      },
      {
        key: "shift_start",
        label: "Shift Start",
        sortable: true
      },
      {
        key: "shift_end",
        label: "Shift End",
        sortable: true
      },
      {
        key: "plan",
        label: "Plan",
        sortable: true
      },
      {
        key: "device",
        label: "Device",
        sortable: true
      },
      {
        key: "owner",
        label: "Owner",
        sortable: true
      },
      {
        key: "contract",
        label: "Contract",
        sortable: true
      },
      {
        key: "should_serve",
        label: "Route",
        sortable: true
      },
      {
        key: "planned",
        label: "Planned",
        sortable: true
      },
      {
        key: "served",
        label: "Served",
        sortable: true
      },
      {
        key: "percent",
        label: "Percent",
        sortable: true
      }
    ]

    const reportWrapper = ref(null)

    /// here use root form ass dialy report setting

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }
    
    const saveDialySetting = (reportName) => {

      let settingData = request.value;
      delete settingData.to;
      delete settingData.from;

      ReportSetting.setSettings(reportName, settingData)
      .then((res) => {
        toaster(root.$root.$t('settings saved successfully!!'), 'scuccess', root.$root.$t('success!!'))
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    
    onMounted(() => {
      if (props.report_type == "setting") {
        ReportSetting.getSetting('containerWashPlan').then((res) => {
          request.value = res;
        })
      }
    })

    const refilterContractByOwner = (ownersIds) => {
      let result = contracts.value.filter((i) => ownersIds.includes(i.contractor_id));
      contracts.value = JSON.parse(JSON.stringify(result));  

      if (ownersIds.length == 0) { contracts.value = JSON.parse(JSON.stringify(contracts.value)) }
    }
    
    return {
      reportData, 
      reportFields, 
      filterIncludedFields, 
      total, 
      from, 
      to, 
      rangeDate,
      tableRef,
      getReport,
      pickerOptions,
      reportWrapper,
      request,
      loading,
      errors,
      owners, 
      contracts, 
      plans,
      reFilterPlans,
      refilterContractByOwner,
      reportLogic,
      dataTableloading,

      //dialy report setting
      saveDialySetting,
      sortData,
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.group-row {
  background-color: #ddd;
}
</style>
